export enum SearchMode {
  AI = 'ai',
}
